import React, { useState } from "react";
import axios from "axios";
import Notiflix from "notiflix";
import { Form, Spinner } from "react-bootstrap";
import {
  messageError,
  messageSuccess,
  messageWarning,
  url_send_notification_all,
  USER_KEY,
} from "../../helper";

export default function NotificationScreen() {
  const [title, setTitle] = useState("");
  const [body, setBody] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const _authHeader = () => ({
    headers: { Authorization: localStorage.getItem(USER_KEY) },
  });

  const _sendNotification = async () => {
    try {
      setLoading(true);
      setResult(null);
      const res = await axios.post(
        url_send_notification_all,
        {
          title: title.trim(),
          body: body.trim() || title.trim(),
        },
        _authHeader()
      );

      const data = res?.data;
      setLoading(false);

      if (res.status === 200 && data?.success) {
        setResult(data?.data || {});
        setTitle("");
        setBody("");
        messageSuccess("ສົ່ງການແຈ້ງເຕືອນສຳເລັດ");
      } else {
        messageWarning(data?.message || "ສົ່ງການແຈ້ງເຕືອນບໍ່ສຳເລັດ");
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      messageError(
        error?.response?.data?.message || "ສົ່ງການແຈ້ງເຕືອນບໍ່ສຳເລັດ"
      );
    }
  };

  const _handleSubmit = (e) => {
    e.preventDefault();
    if (!title.trim()) {
      messageWarning("ກະລຸນາປ້ອນຫົວຂໍ້ການແຈ້ງເຕືອນກ່ອນ");
      return;
    }
    Notiflix.Confirm.show(
      "ແຈ້ງເຕືອນ",
      "ທ່ານຕ້ອງການສົ່ງການແຈ້ງເຕືອນນີ້ຫາຜູ້ໃຊ້ແອັບທຸກຄົນແທ້ ຫຼື ບໍ່?",
      "ຕົກລົງ",
      "ຍົກເລີກ",
      () => _sendNotification()
    );
  };

  return (
    <div className="content-inner pb-0 container-fluid" id="page_layout">
      <div className="row justify-content-center">
        <div className="col-lg-8 col-md-10">
          <div className="card">
            <div className="card-header">
              <h5 className="mb-0">ສົ່ງການແຈ້ງເຕືອນເຂົ້າແອັບ (ທຸກຄົນ)</h5>
            </div>
            <div className="card-body">
              <Form onSubmit={_handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>
                    ຫົວຂໍ້ <span className="text-danger">*</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="ປ້ອນຫົວຂໍ້ການແຈ້ງເຕືອນ"
                    value={title}
                    maxLength={100}
                    disabled={loading}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>ເນື້ອໃນ (ບໍ່ໃສ່ກໍ່ໄດ້)</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="ຖ້າບໍ່ໃສ່ ລະບົບຈະໃຊ້ຫົວຂໍ້ແທນ"
                    value={body}
                    maxLength={500}
                    disabled={loading}
                    onChange={(e) => setBody(e.target.value)}
                  />
                </Form.Group>

                <div className="border rounded p-3 mb-3 bg-light">
                  <small className="text-muted d-block mb-1">
                    ຕົວຢ່າງທີ່ຈະສະແດງໃນແອັບ
                  </small>
                  <div className="fw-bold">{title || "ຫົວຂໍ້..."}</div>
                  <div className="text-muted">
                    {body || title || "ເນື້ອໃນ..."}
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={loading || !title.trim()}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" className="me-2" />
                      ກຳລັງສົ່ງ...
                    </>
                  ) : (
                    "ສົ່ງການແຈ້ງເຕືອນ"
                  )}
                </button>
              </Form>

              {result ? (
                <div className="alert alert-success mt-4 mb-0">
                  <div className="fw-bold mb-1">ສົ່ງການແຈ້ງເຕືອນແລ້ວ</div>
                  <div className="small">
                    ສົ່ງຫາທຸກເຄື່ອງທີ່ຕິດຕັ້ງແອັບ ຜ່ານ topic{" "}
                    <code>{result.topic || "all_users"}</code>
                  </div>
                  {Array.isArray(result.results) ? (
                    <ul className="small mb-0 mt-2">
                      {result.results.map((item) => (
                        <li key={item.platform}>
                          {item.platform}:{" "}
                          {item.success ? (
                            <span className="text-success">ສຳເລັດ</span>
                          ) : (
                            <span className="text-danger">
                              ລົ້ມເຫຼວ ({item.message})
                            </span>
                          )}
                        </li>
                      ))}
                    </ul>
                  ) : null}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
